import { ComponentProps } from "react";
import { Link } from "react-router-dom";
import { preloadPodcastView } from "../LazyImports";
import { useStores } from "@/hooks/useStores";

const PODCAST_PATH = /^\/podd\/([^/?#]+)$/;

/** A Link that starts loading its target's code and data on hover, focus or touch. */
export const PrefetchLink = ({ to, onPointerEnter, onFocus, ...props }: ComponentProps<typeof Link>) => {
    const { podcastStore } = useStores();

    const prefetch = () => {
        const slug = typeof to === "string" ? PODCAST_PATH.exec(to)?.[1] : undefined;
        if (slug) {
            preloadPodcastView();
            podcastStore.prefetchPodcastBySlug(decodeURIComponent(slug));
        }
    };

    return (
        <Link
            to={to}
            onFocus={(event) => {
                prefetch();
                onFocus?.(event);
            }}
            onPointerEnter={(event) => {
                prefetch();
                onPointerEnter?.(event);
            }}
            {...props}
        />
    );
};
